import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '../../../assets/pictures/gamza.png'


const _hoisted_1 = { style: {"bottom":"-6px","position":"absolute"} }
const _hoisted_2 = {
  key: 0,
  class: "gamza-image",
  src: _imports_0,
  alt: ""
}

import { useRoute, useRouter } from 'vue-router';
import { ref, watch, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import '@/assets/styles/layout.scss';

interface MenuItem {
  title: string;
  link: string;
  prependIcon: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminNaviBar',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();
const openGroups = ref<string[]>([]);

const drawer = computed({
  get: () => store.state.drawer,
  set: (value) => store.commit("setDrawer", value)
});

// 현재 경로와 메뉴 링크 비교하여 활성화 상태 확인
const isActive = (link: string): boolean => {
  return route.path === `/${link}`;
};

// 페이지 이동
const navigateTo = (link: string): void => {
  router.push(`/${link}`);
};

// 현재 활성화 페이지가 속한 그룹 찾기
const findGroupByLink = (): string | undefined => {
  return Object.entries(sectionsMap).find(([, items]) => {
    return items.some(item => {
      const fullPath = `/${item.link}`; // item.link에 슬래시 추가
      return fullPath === route.path; // 비교
    });
  })?.[0];
};

const updateOpenGroups = (): void => {
  const activeGroup = findGroupByLink();
  if (activeGroup) {
    if (!openGroups.value.includes(activeGroup)) {
      openGroups.value.push(activeGroup);
    }
  } else {
    console.warn('활성화된 그룹을 찾을 수 없습니다.'); // 그룹을 찾지 못했을 때 경고 로그
  }
};
// 그룹별 아이콘 설정
const getGroupIcon = (groupName: string): string => {
  const icons: Record<string, string> = {
    'HR서비스': 'mdi-face-man-outline',
    '기초정보': 'mdi-information-box-outline',
    '근태관리': 'mdi-clipboard-text-outline',
    '재무회계': 'mdi-lock',
    '위탁급식': 'mdi-lock',
    'CMS 설정': 'mdi-cogs'
  };
  return icons[groupName] || 'mdi-home-outline';
};

// 전체 메뉴 데이터
const sectionsMap: Record<string, MenuItem[]> = {
  '기초정보': [
    { title: '기관관리', link: 'CompBasicInfo', prependIcon: 'mdi-office-building-outline' },
    { title: '기관계약', link: 'CompContract', prependIcon: 'mdi-file-sign' },
    { title: '사원목록', link: 'EmpBasicInfo', prependIcon: 'mdi-account' },
    { title: '사원계약', link: 'EmpContract', prependIcon: 'mdi-handshake-outline' },
  ],
  'HR서비스': [
    { title: '임금기초', link: 'WageBasic', prependIcon: 'mdi-clipboard-edit-outline' },
    { title: '임금대장', link: 'WageLedger', prependIcon: 'mdi-notebook-outline' },
    { title: '임금엑셀업로드', link: 'WageExcelUp', prependIcon: 'mdi-file-excel' },
    // { title: '임금분석', link: 'WageCompare', prependIcon: 'mdi-notebook-edit' },
  ],
  'CMS 설정': [
    { title: 'CMS 테스트', link: 'CmsTest', prependIcon: 'mdi-cogs' },
    { title: 'CMS 목록', link: 'CmsList', prependIcon: 'mdi-cogs' },
  ],
  // '재무회계': [],
  // '위탁급식': [],
};

// 스토어 값 감시하여 메뉴 업데이트
watch(() => store.state.AdminService, (newValue) => {
  if (newValue) {
    openGroups.value = [newValue];
  }
});

// 라우트 변경 감지하여 `openGroups` 업데이트
watch(() => route.path, updateOpenGroups, { immediate: true });

// 초기 메뉴 설정
onMounted(updateOpenGroups);

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_unref(store).state.AdminSisul)
    ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
        key: 0,
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((drawer).value = $event)),
        id: "MenuNavi",
        "disable-resize-watcher": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, {
            modelValue: openGroups.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((openGroups).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-home-outline",
                title: "Home",
                class: _normalizeClass({ 'bg-grey-darken-2': isActive('/') }),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateTo('AdminIndexPage')))
              }, null, 8, ["class"]),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sectionsMap, (group, groupName) => {
                return _createVNode(_component_v_list_group, {
                  key: groupName,
                  value: groupName
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_list_item, _mergeProps(props, {
                      "prepend-icon": getGroupIcon(groupName),
                      title: groupName
                    }), null, 16, ["prepend-icon", "title"])
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: item.title,
                        "prepend-icon": item.prependIcon,
                        title: item.title,
                        class: _normalizeClass({ 'bg-grey-darken-2': isActive(item.link) }),
                        onClick: ($event: any) => (navigateTo(item.link))
                      }, null, 8, ["prepend-icon", "title", "class", "onClick"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_1, [
            (_unref(store).getters.id === 'hamwoori25' && _unref(store).getters.name === '김아름')
              ? (_openBlock(), _createElementBlock("img", _hoisted_2))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})